var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { attrs: { title: "Perfil de la empresa", "title-color": "primary" } },
        [
          _c(
            "vs-tabs",
            { staticStyle: { "min-height": "500px" } },
            [
              _c(
                "vs-tab",
                { attrs: { label: "Empresa" } },
                [
                  _vm.datos
                    ? _c("empresa-perfil", { attrs: { empresa: _vm.datos } })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "vs-tab",
                { attrs: { label: "Casa Matriz" } },
                [
                  _vm.datos
                    ? _c("empresa-casa-matriz", {
                        attrs: {
                          iut: _vm.datos.iut,
                          sucursales: _vm.sucursales
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "vs-tab",
                { attrs: { label: "Sucursales" } },
                [
                  _vm.datos
                    ? _c("empresa-sucrusales", {
                        attrs: {
                          iud: _vm.datos.iut,
                          codigoSii: _vm.datos.codigoSII,
                          sucursales: _vm.sucursales
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }